import { isElement } from './dom/node';

export function isQuoteElement(node: Node | null): node is HTMLQuoteElement {
  return isElement(node) && ['BLOCKQUOTE', 'Q'].includes(node.tagName);
}

export function isBlockquoteElement(node: Node | null): boolean {
  return isElement(node) && node.tagName === 'BLOCKQUOTE';
}
